import { render, staticRenderFns } from "./centered-order.vue?vue&type=template&id=716003c2&scoped=true"
import script from "./centered-order.vue?vue&type=script&lang=js"
export * from "./centered-order.vue?vue&type=script&lang=js"
import style0 from "./centered-order.vue?vue&type=style&index=0&id=716003c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716003c2",
  null
  
)

export default component.exports